

































































































import Vue from "vue";
import data from "@/data/userData";
import Dan from "@/models/Dan";
import User from "@/models/User";

export default Vue.extend({
  created() {
    const initialData = data;
    Dan.insert({ data: initialData });
  },

  computed: {
    dans(): Dan[] {
      const danArray: Dan[] =
        Dan.query()
          .where((dan: Dan) => {
            return dan.hierarchy?.includes("natrep");
          })
          .orderBy("dan", "desc")
          .get() || [];
      danArray?.forEach((dan: Dan) => {
        const validUsers: User[] =
          dan.data?.filter((user: User) => {
            return user?.repposition;
          }) || [];
        dan.data =
          validUsers?.sort((a, b) => {
            return a.repposition - b.repposition;
          }) || [];
      });
      return danArray;
    },

    users(): User[] {
      return (
        this.dans
          ?.map((dan: Dan) => {
            dan.data?.forEach((data: User) => {
              data.danclass = dan.danclass;
            });
            return dan.data;
          })
          ?.reduce((result, item) => {
            return result.concat(item);
          })
          ?.sort((a, b) => {
            return a.repposition - b.repposition;
          }) || []
      );
    },
  },

  methods: {
    resetScrollToContainerTop(): void {
      const container: HTMLElement | null =
        document?.querySelector(".container");
      if (container) {
        container.scrollTop = 0;
      }
    },

    getImgUrl(pic: string): any {
      return require(`../assets/images/${pic}`);
    },
  },

  mounted() {
    this.resetScrollToContainerTop();
  },
});
